import { types } from "../action-types";

const initialState = {
  loading: false,
  invites: [],
  totalCounts: null,
  error: false,
};

const getInvites = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.invites)) return payload.invites;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.invites)) return payload.data.invites;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
};

const getTotalCounts = (payload) =>
  payload?.totals ||
  payload?.counts ||
  payload?.statusCounts ||
  payload?.totalCounts ||
  payload?.totalCount ||
  payload?.total ||
  payload?.data?.totals ||
  payload?.data?.counts ||
  payload?.data?.statusCounts ||
  payload?.data?.totalCounts ||
  payload?.data?.totalCount ||
  payload?.data?.total ||
  null;

const inviteTrackingInvitesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_INVITE_TRACKING_INVITES:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case types.FETCH_INVITE_TRACKING_INVITES_SUCCESS:
      return {
        ...state,
        loading: false,
        invites: getInvites(action.payload),
        totalCounts: getTotalCounts(action.payload),
        error: false,
      };

    case types.FETCH_INVITE_TRACKING_INVITES_FAILURE:
      return {
        ...state,
        loading: false,
        invites: [],
        totalCounts: null,
        error: true,
      };

    default:
      return state;
  }
};

export default inviteTrackingInvitesReducer;
